// import Templates from "views/basegrid/templates";
import BaseGrid from "../sections/view";
import { rule } from "../../helpers/templates";
import { checkedIconAlt, notCheckedIconAlt } from "../../helpers/icons";

export default class MatrixView extends BaseGrid {
	config() {
		const _ = this.app.getService("locale")._;
		this.Sorting = { column: "", dir: "" };

		const ui = super.config();

		webix.extend(
			ui,
			{
				css: "webix_um_matrix",
				headerRowHeight: 56,
				rowHeight: 62,
				rowLineHeight: 29,
				leftSplit: 1,
				select: false,
				on: {
					onItemClick: id => this.Toggle(id),
					// to sort descendant by default
					onHeaderClick: header => this.ToggleColumnSorting(header.column),
				},
			},
			true
		);

		return this.GetRoleColumns().then(roles => {
			ui.columns = [
				{
					id: "short",
					header: _("Rules"),
					width: 220,
					css: "webix_um_column_name",
					sort: "string",
					template: rule(this),
				},
				...roles,
			];

			return ui;
		});
	}

	init() {
		return this.GetData();
	}

	GetData() {
		const local = this.app.getService("local");
		return Promise.all([local.roles(), local.rules()]).then(res => {
			const data = this.CreateMatrix(res[0], res[1]);
			this.InitSelf(data);
		});
	}

	SearchCompare(value, rule) {
		return (
			rule.short.toLowerCase().indexOf(value) > -1 ||
			rule.long.toLowerCase().indexOf(value) > -1
		);
	}

	Save(id) {
		const roleId = id.column;
		let role = this.app
			.getService("local")
			.roles(true)
			.getItem(roleId);

		role.rules = [];
		this.$$("table").data.each(row => {
			if (row[roleId]) role.rules.push(row.id);
		});
		this.app.getService("operations").updateRole(roleId, role);
	}

	Toggle(id) {
		let item = this.$$("table").getItem(id);
		const column = id.column;
		if (column != "short") {
			item[column] = !item[column];
			item.selected = !item.selected;
			this.$$("table").updateItem(id, item);
			this.Save(id);
		}
	}

	GetRoleColumns() {
		return this.app
			.getService("local")
			.roles()
			.then(roles => {
				const columns = [];
				roles.data.each(role => {
					columns.push({
						id: role.id,
						header: {
							text: `<span>${role.name}</span>`,
							css: "webix_um_center_column webix_um_names",
						},
						minWidth: 100,
						fillspace: 1,
						css: "webix_um_center_column",
						template: obj => {
							return obj[role.id] ? checkedIconAlt : notCheckedIconAlt;
						},
					});
				});

				return columns;
			});
	}

	CreateMatrix(roles, rules) {
		const data = rules.serialize().map(({ id, short, long }) => {
			let roleAssigned = {};
			roles.data.each(role => {
				roleAssigned[role.id] = role.rules
					? role.rules.indexOf(id) > -1
					: false;
			});
			return { id, short, long, ...roleAssigned };
		});
		return data;
	}

	ToggleColumnSorting(column) {
		if (column != "short") {
			let dir =
				this.Sorting.column == column && this.Sorting.dir == "desc"
					? "asc"
					: "desc";
			this.$$("table").sort({ by: column, dir: dir, as: "string" });
			this.$$("table").markSorting(column, dir);
			this.Sorting.dir = dir;
		}
		this.Sorting.column = column;
	}
}
